import {NAMES} from "@/scripts/components/ab-lightbox/ab-lightbox.constants";
import {AbModalConfigInterface} from "@/scripts/modules/ab-modal/ab-modal.types";
import {AbModal} from "@/scripts/modules/ab-modal/ab-modal.class";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";
import "./_ab-lightbox.scss";

export class AbLightbox {

  public static init() {
    document.addEventListener('click', (event) => {
      const clickedElement = event.target as HTMLElement;
      if (!clickedElement) return;
      const parentHref = clickedElement.closest("a")?.getAttribute("href");
      if (!parentHref) return;
      const isLinkToImage = [".jpeg", ".jpg", ".webp", ".png"]
        .some((imgExtension: string) =>
          parentHref.includes(imgExtension)
        );
      if (!isLinkToImage) return;
      const isLightboxDisabled = !!clickedElement.closest(`.${NAMES.LIGHTBOX_DISABLED}`);
      if (isLightboxDisabled) return;
      event.preventDefault();
      AbLightbox.openLightbox(parentHref);
    });
  }

  private static lightboxModalConfig: AbModalConfigInterface = {
    autoOpen: true,
    hideBodyOverflow: true,
    handleBackBrowser: true,
    attributes: {
      classesModal: 'ab-modal--full',
      classesBackdrop: null,
      classesInner: null,
      classesWrapper: 'ab-modal__wrapper--bg-dark',
      header: {
        show: true,
        closeButtonText: 'Chiudi',
        closeButton: true,
        classes: 'ab-modal__header--overlay',
      },
    },
    id: 'image'
  }

  private static openLightbox(imgSrc: string) {
    const innerHtml = `<img class="${NAMES.CLASS_IMAGE}" src="${imgSrc}" alt="" />`;
    const lightBoxElement = createDomElementHandler("div", NAMES.CLASS_ROOT, undefined, innerHtml);

    let modal: AbModal;

    // Gestione click ( se all'interno della lightbox ma non sull'immagine chiudo modale)
    const clickOnLightbox = (ev: MouseEvent) => {
      const clickedOnImage = (ev?.target as HTMLElement)?.classList?.contains(NAMES.CLASS_IMAGE);
      if (clickedOnImage)  return;
      modal.hide();
    }

    lightBoxElement.addEventListener("click", clickOnLightbox);

    AbLightbox.lightboxModalConfig.id = imgSrc?.split('/').at(-1).replaceAll(' ', '-') || 'immagine';
    AbLightbox.lightboxModalConfig.handlers = {
      onClose: () => {
        // Alla chusura della modale rimuovo listener ed elemento lightbox
        lightBoxElement.removeEventListener("click", clickOnLightbox);
        lightBoxElement.remove();
      }
    }

    modal = new AbModal(
      AbLightbox.lightboxModalConfig,
      lightBoxElement
    );
    modal.show();
  }
}